<template>
  <div class="side-box" :class="{ active: opened.length > 0 }">
    <span class="side-box__overlay" />
    <div
      v-if="service"
      class="side-box__inner"
      :class="{
        opened: opened.indexOf('serviceDetail') >= 0,
        'last-active': opened.indexOf('serviceDetail') == opened.length - 1
      }"
    >
      <div
        class="side-box__header d-flex justify-content-between align-items-center"
      >
        <div
          class="atom-back atom-back--gray"
          @click="closeBox('serviceDetail')"
        >
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" /><span>{{
              $t("zpet")
            }}</span>
          </div>
        </div>
        <!--button class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon"><img src="@/assets/icons/actions/ico-btn-ulozit.svg"></div>{{ $t("ulozitRoutovaciSkupinu") }}
        </button-->
      </div>
      <div class="side-box__title">
        <h2>{{ $t("detailSluzby") }} {{ service.custServiceName }}</h2>
      </div>
      <div class="side-box__content">
        <div class="my-4">
          <div class="side-box__row d-flex align-items-start mt-3">
            <span
              class="side-box__content__label side-box__content__label--large text gray-text"
            >{{ $t("idSluzby") }}</span>
            <span class="side-box__content__value ml-3">{{
              service.custServiceId
            }}</span>
          </div>
          <div class="side-box__row d-flex align-items-start mt-3">
            <span
              class="side-box__content__label side-box__content__label--large text gray-text"
            >{{ $t("tarifName") }}</span>
            <span class="side-box__content__value ml-3">{{
              service.tarifName
            }}</span>
          </div>
          <div class="side-box__row d-flex align-items-start mt-3">
            <span
              class="side-box__content__label side-box__content__label--large text gray-text"
            >{{ $t("custState") }}</span>
            <span class="side-box__content__value ml-3">{{
              service.custState
            }}</span>
          </div>
        </div>
        <div class="my-4">
          <a
            :class="{ opened: projectsOpened }"
            class="atom-form-group__toggler"
            @click="projectsOpened = projectsOpened ? false : true"
          >{{ $t("PACKAGE")
          }}<img
            src="@/assets/icons/arrows/arr-orange-down.svg"
            class="atom-form-group__toggler__arrow"
          /></a>

          <div
            class="atom-form-group__content"
            :class="{ opened: projectsOpened }"
          >
            <div v-for="parameter in parametersNames.package" :key="parameter">
              <div
                v-if="getParameter(parameter).value"
                class="side-box__row d-flex align-items-start mt-3"
              >
                <span
                  class="side-box__content__label side-box__content__label--large text gray-text"
                >
                  {{ $t(`COUNTER-${parameter}`) }}
                </span>
                <span class="side-box__content__value ml-3">
                  {{ $t(getParameter(parameter).value) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="my-4">
          <a
            :class="{ opened: countersOpened }"
            class="atom-form-group__toggler"
            @click="countersOpened = countersOpened ? false : true"
          >{{ $t("DATA")
          }}<img
            src="@/assets/icons/arrows/arr-orange-down.svg"
            class="atom-form-group__toggler__arrow"
          /></a>

          <div
            class="atom-form-group__content"
            :class="{ opened: countersOpened }"
          >
            <div v-for="parameter in parametersNames.data" :key="parameter">
              <div
                v-if="getParameter(parameter).value"
                class="side-box__row d-flex align-items-start mt-3"
              >
                <span
                  class="side-box__content__label side-box__content__label--large text gray-text"
                >
                  {{ $t(`COUNTER-${parameter}`) }}
                </span>
                <span class="side-box__content__value ml-3">
                  {{ $t(getParameter(parameter).value) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="my-4">
          <a
            :class="{ opened: limitsOpened }"
            class="atom-form-group__toggler"
            @click="limitsOpened = limitsOpened ? false : true"
          >{{ $t("SMS")
          }}<img
            src="@/assets/icons/arrows/arr-orange-down.svg"
            class="atom-form-group__toggler__arrow"
          /></a>

          <div
            class="atom-form-group__content"
            :class="{ opened: limitsOpened }"
          />
        </div>
      </div>
    </div>
    <!--save-confirmation-modal :opened="openedEndpointConfirmation" :text="'chceteUlozitProvedeneZmeny'" @yes="runSave()" @no="closeBox('serviceDetail')" @close="toggleConfirmation"/-->
    <!--div v-if="errorsToTranslate.length > 0">
      <error-modal :opened="openedError" :centered="true" :errors="errorsToTranslate" @close="openedError = false;"/>
    </div-->
  </div>
</template>

<script>
//import _ from "lodash";
import axios from "axios";
//import SaveConfirmationModal from "@/components/confirmations/save.vue";
//import ErrorModal from "@/components/confirmations/translatedErrors.vue";
export default {
  components: {
    //"save-confirmation-modal": SaveConfirmationModal,
    //"error-modal": ErrorModal
  },
  props: {
    customer: Object,
    service: Object,
    opened: Array
  },
  data() {
    return {
      limitsOpened: true,
      countersOpened: true,
      projectsOpened: true,
      counters: [],
      projects: [],
      parametersNames: {
        package: [
          "DATA_SIM_COUNT",
          "DATA_SIM_CONNECTION_TECHNOLOGY",
          "DATA_SIM_TYPE",
        ],
        data: [
          "DATA_SIM_SECURITY_CONFIG",
          "DATA_SIM_METHOD_TRANSMISSION",
          "DATA_SIM_ROAMING_ZONE",
          "DATA_SIM_LIMIT_PER_SIM",
          "DATA_SIM_POOLING_PLAN",
          "DATA_SIM_LIMIT_TYPE",
        ]
      },
      //openedConfirmation: false,
      //errorsToTranslate: [],
      //openedError: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loadCounters();
    this.loadProjects();
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box);
    },
    closeBox(box) {
      if (box === "serviceDetail") {
        //this.resetValues();
        this.$emit("closeBox", box);
      } else {
        //this.resetValues();
        this.errors.endpoint = "";
        this.$emit("closeBox", box);
      }
    },
    loadProjects() {
      this.projects = [];
      axios
        .get(
          process.env.VUE_APP_API +
            "/services/" +
            this.service.custServiceId +
            "/projects"
        )
        .then(result => {
          this.projects = result.data.data;
        })
        .catch(() => {});
    },
    loadCounters() {
      this.counters = [];
      axios
        .get(
          process.env.VUE_APP_API + "/services/" + this.service.custServiceId
        )
        .then(result => {
          this.counters = result.data.data;
        })
        .catch(() => {});
    },
    getParameter(name) {
      let param = this.service.parameters.filter(
        parameter => parameter.name == name
      );
      return param.length > 0 ? param[0] : "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
